import { useArtifactDownloadUrl } from './useArtifactDownloadUrl'

/**
 * Fetches the presigned download URL for an artifact's audio file.
 * @see useArtifactDownloadUrl
 */
export const useArtifactAudioUrl = useArtifactDownloadUrl
